var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"630px","scrollable":""},on:{"click:outside":_vm.close},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(_vm.customComponent,_vm._b({tag:"component",on:{"cancel":_vm.close,"submit":_vm.handleSubmit}},'component',{
      formTitle: _vm.formTitle,
      customVars: _vm.customVars,
      isLocked: _vm.isLendingStrategyLocked,
      isLoading: _vm.isLoading,
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }